import React from 'react';

import classnames from 'classnames';

import { useSize, type SizeType } from '../../../features/config';
import { Skeleton, type SkeletonProps } from '../Skeleton';

import styles from '../Skeleton.module.scss';

export type SkeletonMultilineProps = SkeletonProps & {
    size?: SizeType;
    lines: number;
    type?: 'text' | 'rows';
};

export const SkeletonMultiline = ({
    className,
    size,
    lines,
    width,
    type = 'text',
    ...rest
}: SkeletonMultilineProps) => {
    const mergedSize = useSize(size, 'small', 'SkeletonMultiline');
    return (
        <div
            className={classnames(styles.multiline, styles[mergedSize], styles[type], className)}
            style={{ width }}
        >
            {Array.from({ length: lines }).map((_, index) => (
                <Skeleton
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    className={styles.item}
                    {...rest}
                />
            ))}
        </div>
    );
};
